module.exports = __webpack_public_path__ + "img/002.2b3dd871.png";